import { PhasrDictionaryEntry } from '../types';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';

export class PhasrRuleNamesDataProvider {

  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @protected
   */
  static getRemoteData(
    page: number,
    limit: number,
    searchString: string = '',
  ): Array<any> {
    const dictionary = Application.Main.getPhasrDictionary();

    let filteredResults = Object.entries(dictionary).map(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        return {...value, ruleId: key};
      }
      return value;
    });

    if (searchString) {
      filteredResults = filteredResults.filter((item: PhasrDictionaryEntry) =>
        item.rule_name.toLowerCase().includes(searchString.toLowerCase())
      );
    }

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    return filteredResults.slice(startIndex, endIndex);
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response: Array<any>): ComplexSuggestedItem[] {
    return response.map((item: PhasrDictionaryEntry) => {
      return {
        label: item.rule_name,
        value: item.ruleId,
      };
    });
  }

}
